import { Component, inject, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize } from 'rxjs';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { AppUserService } from 'src/app/proxy/users/app-user.service';
import { CreateUserReportDto } from '@proxy/users/dtos';

interface ReportReason {
  value: string;
  label: string;
  description: string;
}

@Component({
  selector: 'app-report-user',
  templateUrl: './report-user.component.html',
  styleUrls: ['./report-user.component.scss'],
})
export class ReportUserComponent extends AppComponentBase implements OnInit {
  reportForm: FormGroup;
  reportReasons: ReportReason[] = [];
  targetUser: any;
  isSubmitting = false;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private appUserService: AppUserService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.targetUser = this.config.data?.user;
    this.initForm();
    this.initReportReasons();
  }

  private initForm(): void {
    this.reportForm = this.fb.group({
      reasonCode: ['', Validators.required],
    });
  }

  private initReportReasons(): void {
    this.reportReasons = [
      {
        value: 'hate',
        label: this.L('::Report:Reason1:Label'),
        description: this.L('::Report:Reason1:Description'),
      },
      {
        value: 'harassment',
        label: this.L('::Report:Reason2:Label'),
        description: this.L('::Report:Reason2:Description'),
      },
      {
        value: 'violent',
        label: this.L('::Report:Reason3:Label'),
        description: this.L('::Report:Reason3:Description'),
      },
      {
        value: 'child_safety',
        label: this.L('::Report:Reason4:Label'),
        description: this.L('::Report:Reason4:Description'),
      },
      {
        value: 'privacy',
        label: this.L('::Report:Reason5:Label'),
        description: this.L('::Report:Reason5:Description'),
      },
      {
        value: 'spam',
        label: this.L('::Report:Reason6:Label'),
        description: this.L('::Report:Reason6:Description'),
      },
      {
        value: 'suicide_self_harm',
        label: this.L('::Report:Reason7:Label'),
        description: this.L('::Report:Reason7:Description'),
      },
      {
        value: 'sensitive_media',
        label: this.L('::Report:Reason8:Label'),
        description: this.L('::Report:Reason8:Description'),
      },
      {
        value: 'impersonation',
        label: this.L('::Report:Reason9:Label'),
        description: this.L('::Report:Reason9:Description'),
      },
      {
        value: 'violent_groups',
        label: this.L('::Report:Reason10:Label'),
        description: this.L('::Report:Reason10:Description'),
      },
    ];
  }

  close(): void {
    this.ref.close({ submitted: false });
  }

  submitReport(): void {
    if (this.reportForm.invalid) {
      return;
    }

    const reportData: CreateUserReportDto = {
      reportedId: this.targetUser?.id,
      reason: this.reportForm.value.reasonCode,
      giftFanDonationId: this.targetUser?.giftFanDonationId,
    };

    this.isSubmitting = true;
    this.appUserService
      .createReportUserByInput(reportData)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: () => {
          this.ref.close({
            submitted: true,
            data: reportData,
          });
        },
        error: error => {
          console.error('Error reporting user:', error);
        },
      });
  }
}
